import React from 'react';
import { I18nForCards } from '@cp-cards/rich-cards-localization';
import cardMapper from './card-mapper';
import logger, { LoggingEvents } from '../utilities/logger';

const Card = (props) => {
  const { queryParams, postData, initialState } = props;
  const { localeCode, translatedStringsForCards, jwtToken } = initialState;
  const templateId =
    (queryParams && queryParams.templateId) || postData.templateId;

  const Component =
    cardMapper[
      Object.keys(cardMapper).find(
        (key) => key.toLowerCase() === templateId.toLowerCase(),
      )
    ];

  logger.setConversationId(queryParams.convId);
  logger.setAuthToken(jwtToken);

  if (Component) {
    const l10n = new I18nForCards();
    l10n.setLocale(localeCode, translatedStringsForCards);
    return (
      <div>
        <Component
          initialState={initialState}
          queryParams={queryParams}
          postData={postData}
          l10n={l10n}
        />
      </div>
    );
  }
  logger.error(
    LoggingEvents.CardRenderError,
    `The Card could not render for ${templateId} with ${queryParams}`,
  );
  return new Error('Base component failed');
};

export default Card;
